export default __webpack_public_path__ + "static/media/heart.a65ad04f.svg";